import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "AuthSocialButtons auth-social-buttons" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

import { ref } from 'vue';
import { Auth, AuthError, ILoginData } from 'Auth';
import { useBrowserBackButtonEvent } from '@/composables/useBrowserBackButtonEvent';
import { BaseButton } from 'Components/Base/BaseButton';
import { BaseNotificationInline } from 'Components/Base/BaseNotificationInline';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthSocialButtons',
  props: {
    signup: { type: Boolean },
    resetError: { type: Boolean },
    keepLoadingOnSuccess: { type: Boolean }
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const socialLoading = ref('');
const loginError = ref('');

const {
  setBrowserBackButtonListener,
  removeBrowserBackButtonListener,
} = useBrowserBackButtonEvent(() => {
  socialLoading.value = '';
});

async function onSocialClick(socialName: string) {
  socialLoading.value = socialName;
  try {
    setBrowserBackButtonListener();
    const loginData = await Auth.socialLogin(socialName);
    emit('success', loginData);
    if (!props.keepLoadingOnSuccess) socialLoading.value = '';
  } catch (error) {
    socialLoading.value = '';
    loginError.value = (error as AuthError).message;
  } finally {
    removeBrowserBackButtonListener();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseButton), {
      class: "auth-social-buttons__button is--google",
      loading: socialLoading.value === 'google-oauth2',
      tabindex: "-1",
      color: "primary-dark",
      large: "",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onSocialClick('google-oauth2')), ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          alt: "google-icon",
          class: "svg-icon auth-social-buttons__button-icon",
          innerHTML: require(`!!raw-loader!images/svg-icons/google-social-icon.svg`).default
        }, null, 8, _hoisted_2),
        _cache[3] || (_cache[3] = _createTextVNode(" Log In with Google "))
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_unref(BaseButton), {
      class: "auth-social-buttons__button is--linkedin",
      loading: socialLoading.value === 'linkedin',
      tabindex: "-1",
      color: "primary-dark",
      large: "",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onSocialClick('linkedin')), ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          alt: "linkedin-icon",
          class: "svg-icon auth-social-buttons__button-icon linkedin-icon",
          innerHTML: require(`!!raw-loader!images/svg-icons/brands-linkedin-in.svg`).default
        }, null, 8, _hoisted_3),
        _cache[4] || (_cache[4] = _createTextVNode(" Log In with LinkedIn "))
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_unref(BaseButton), {
      class: "auth-social-buttons__button is--facebook",
      loading: socialLoading.value === 'facebook',
      tabindex: "-1",
      color: "primary-dark",
      large: "",
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onSocialClick('facebook')), ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          alt: "facebook-icon",
          class: "svg-icon auth-social-buttons__button-icon",
          innerHTML: require(`!!raw-loader!images/svg-icons/brands-facebook-f.svg`).default
        }, null, 8, _hoisted_4),
        _cache[5] || (_cache[5] = _createTextVNode(" Log In with Facebook "))
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_unref(BaseNotificationInline), {
      show: Boolean(loginError.value),
      class: "auth-social-buttons__notification"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", { innerHTML: loginError.value }, null, 8, _hoisted_5)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})